/**
 * Extracts the different parts of a URL from the given URL string.
 * If the URL starts with 'data:', it returns the URL as is.
 * Otherwise, it extracts the protocol, path, domain, and name from the URL.
 *
 * @param {string} url - The URL string to extract parts from.
 * @returns {object} - An object containing the extracted parts of the URL.
 */
export default function getRequestPartsFromUrl(url) {
	if (url.startsWith('data:')) return url

	const nameParts = url.trim().replace(/\/$/, '').split('/')
	const name = nameParts[nameParts.length - 1]

	const parts = {
		protocol: '',
		path: url,
		domain: '',
		name: name || url,
	}

	try {
		const {protocol, pathname, hostname} = new URL(url)
		parts.protocol = protocol
		parts.path = pathname
		parts.domain = hostname
	} catch (error) {
		// do nothing
	}
	return parts
}
